<script setup>
import EvidenceList from './EvidenceList.vue'
import { useAuditText } from './audit-text.js'
import { asArray } from './run-observer.js'

defineProps({
  // 每行 { key, title, meta, text, record }：title 粗体标签，meta 小字（来源轮次等），record 是带 evidence_ids 的原记录。
  rows: { type: Array, required: true },
  sources: { type: Map, required: true },
})

const { tr } = useAuditText()
</script>

<template>
  <ul v-if="rows.length" class="au-records">
    <li v-for="row in rows" :key="row.key" class="au-record">
      <div class="au-record__head">
        <strong>{{ row.title }}</strong>
        <span v-if="row.meta" class="au-muted">{{ row.meta }}</span>
      </div>
      <p class="au-body">{{ row.text || '—' }}</p>
      <details v-if="asArray(row.record.evidence_ids).length" class="au-evidence">
        <summary>{{ tr('sources.evidence', { count: row.record.evidence_ids.length }) }}</summary>
        <EvidenceList :record="row.record" :sources="sources" />
      </details>
    </li>
  </ul>
  <p v-else class="au-empty">{{ tr('empty') }}</p>
</template>
